var React = require('react');

function IconCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m33.964 85.821-32.5-32.5a5 5 0 0 1 0-7.071l7.071-7.071a5 5 0 0 1 7.071 0L37.5 61.072 84.394 14.18a5 5 0 0 1 7.07 0l7.072 7.07a5 5 0 0 1 0 7.072l-57.5 57.5a5 5 0 0 1-7.072 0Z"}));
}

IconCheckmark.defaultProps = {"fill":"currentColor","viewBox":"0 0 100 100"};

module.exports = IconCheckmark;

IconCheckmark.default = IconCheckmark;
